import { CardTheme, FixedCard } from '../../../elements/molecules/card/Card';

export function OsasFlexMraActionCard() {
    return (
        <FixedCard
            body={
                'Je hebt samen met je arts gekozen voor een beugel (MRA) tegen slaapapneu. Een gespecialiseerde tandarts begeleidt je hierbij. Je maakt hiervoor zelf een afspraak.'
            }
            buttonsText={['Lees hoe je een afspraak maakt']}
            cardTitle={'Afspraak met de tandarts'}
            linksTo={[`/osas/dentistInformation`]}
            theme={CardTheme.white}
        />
    );
}
